import { login, mfaVerify, logout, googLogin, googAuth } from '@/api/auth/login'
import { setLogin, removeUID, removeUsername } from '@/utils/auth'

const user = {
  state: {
    uid: '',
    username: ''
  },

  mutations: {
    SET_UID: (state, uid) => {
      state.uid = uid
    },
    SET_UNAME: (state, username) => {
      state.username = username
    }
  },

  actions: {
    Login ({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password, userInfo.recaptcha).then(res => {
          setLogin(res.data, resolve, commit)
        }).catch(err => {
          reject(err)
        })
      })
    },

    MFALogin ({ commit }, token) {
      return new Promise((resolve, reject) => {
        mfaVerify(token).then(res => {
          setLogin(res.data, resolve, commit)
        }).catch(err => {
          reject(err)
        })
      })
    },

    GoogLogin ({ commit }) {
      return new Promise((resolve, reject) => {
        googLogin().then(res => {
          const data = res.data
          if (data.redirect_url) {
            window.location.replace(data.redirect_url)
          }
          resolve()
        }).catch(err => {
          reject(err)
        })
      })
    },

    GoogAuth ({ commit }, googState, googCode) {
      return new Promise((resolve, reject) => {
        googAuth(googState, googCode).then(res => {
          setLogin(res.data, resolve, commit)
        }).catch(err => {
          reject(err)
        })
      })
    },

    SetInfo ({ commit }, userInfo) {
      commit('SET_UID', userInfo.uid)
      commit('SET_UNAME', userInfo.username)
    },

    LogOut ({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout().then(() => {
          resolve()
        }).catch(err => {
          reject(err)
        }).then(() => {
          commit('SET_UID', '')
          removeUID()
          removeUsername()
        })
      })
    },

    FedLogOut ({ commit }) {
      return new Promise(resolve => {
        commit('SET_UID', '')
        removeUID()
        removeUsername()
        resolve()
      })
    }
  }
}

export default user
